import { parse } from "date-fns";

import { IMailbox } from "store/entities/mailboxes/interfaces";

export default {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  deserialize(mailbox: Record<string, any>): IMailbox {
    return {
      id: mailbox.ID,
      name: mailbox.name,
      teamId: mailbox.teamID,
      agentId: mailbox.agentID,
      description: mailbox.description || "",
      flags: mailbox.flags
        ? {
            inboxUsed: mailbox.flags.inboxUsed || false,
          }
        : { inboxUsed: false },
      ...(mailbox.updatedAt ? { updatedAt: parse(mailbox.updatedAt) } : {}),
    };
  },

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  deserializeCollection(mailboxes: Record<string, any>[]): IMailbox[] {
    return mailboxes.map(this.deserialize);
  },

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  serialize(mailbox: Partial<IMailbox>): Record<string, any> {
    return {
      name: mailbox.name,
      teamID: mailbox.teamId,
      agentID: mailbox.agentId,
      description: mailbox.description || "",
    };
  },
};
